import { IFormJBPHPContactChangeRequest } from 'legacy/lut/classes/models/partner360/IFormHPContacts'

export const hasRole = (contact: IFormJBPHPContactChangeRequest, roleName: string) =>
  contact.Roles?.split(',')
    .map((r) => r.trim())
    .includes(roleName) ?? false
